import { createContext, useContext } from 'react';

/**
 * BrandingContext — makes branding config and the API base available app-wide.
 *
 * Shape: { branding: { org_name, tagline, primary_color, accent_color, logo, ... }, API: string }
 */
export const BrandingContext = createContext({});

/**
 * Convenience hook for consuming BrandingContext.
 * Must be used inside a BrandingContext.Provider.
 */
export function useBranding() {
  return useContext(BrandingContext);
}
